import type { GetPublishedQSetsQuery } from '@exam-management/graphql';

export default function transformPublishedQSetsToQSetRows(
  publishedQSets?: GetPublishedQSetsQuery['excSearchQSets']['qSets'],
) {
  if (!publishedQSets) return [];
  return publishedQSets.map((qSet) => ({
    id: qSet.id,
    code: qSet.code,
    status: qSet.status,
    lastPublishedAt: qSet.lastPublishedAt ? new Date(qSet.lastPublishedAt) : null,
    qConfig: {
      code: qSet.qConfig.code,
      name: qSet.qConfig.name,
    },
  }));
}
